import { buildPanelItem } from "../helpers/buildPanelItem";
import { scoresFaceMatchPanel } from "./scoresFaceMatch";
import { scoresLivenessPanel } from "./scoresLiveness";
import { Collapse } from "antd";
import { Label } from "../components/Label";

export const scoresPanel = [
  buildPanelItem(
    "1",
    Label({ label: "face_match", type: "object" }),
    null,
    <Collapse items={scoresFaceMatchPanel} />,
  ),
  buildPanelItem(
    "2",
    Label({ label: "liveness", type: "object" }),
    null,
    <Collapse items={scoresLivenessPanel} />,
  ),
];
